import React, { useState, useRef, useEffect } from 'react';
import { Globe, ChevronDown, Check } from 'lucide-react';
import { LANGS } from '../lib/langs';
import { useI18n } from '../context/I18nContext';

export default function LanguageSelector({ onChanged }) {
  const { lang, setLang } = useI18n();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', onClick);
    return () => document.removeEventListener('mousedown', onClick);
  }, []);

  const current = LANGS.find((l) => l.code === lang) || LANGS[0];

  return (
    <div className="relative" ref={ref}>
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        className="inline-flex items-center gap-1.5 text-sm text-slate-600 hover:text-[#0d3a8a] px-2 py-1 rounded-md"
        data-testid="language-selector"
      >
        <Globe size={14} />
        <span>{current.flag} {current.name}</span>
        <ChevronDown size={14} />
      </button>
      {open && (
        <div className="absolute right-0 mt-2 w-56 max-h-80 overflow-auto bg-white border border-slate-200 rounded-xl shadow-lg z-50 p-1">
          {LANGS.map((l) => (
            <button
              key={l.code}
              onClick={() => { setLang(l.code); setOpen(false); if (onChanged) onChanged(l.code); }}
              className={`w-full text-left flex items-center gap-2 px-3 py-2 rounded-lg text-sm ${
                lang === l.code ? 'bg-[#eef4fb] text-[#0d3a8a] font-semibold' : 'text-slate-700 hover:bg-slate-50'
              }`}
            >
              <span className="text-base">{l.flag}</span>
              <span className="flex-1">{l.name}</span>
              <span className="text-[10px] uppercase text-slate-400">{l.code}</span>
              {lang === l.code && <Check size={14} className="text-[#0d3a8a]" />}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
